import { ReactComponent as NigeriaMapSvg } from '../assets/images/projects/nigeria-map.svg'

const NigeriaMap = ({ className = '', highlightAll = false, highlightStates = [] }) => {
  const stateRules = highlightStates
    .map((id) => `
        .nigeria-map #${id} {
          fill: #007DD6;
        }
        .nigeria-map #${id}:hover {
          fill: #005bb5;
        }
      `)
    .join('\n')

  return (
    <div className={`nigeria-map ${highlightAll ? 'highlight-all' : ''} ${className}`}>
      <style>{`
        .nigeria-map svg {
          width: 100%;
          height: 100%;
        }
        .nigeria-map path {
          fill: #E6E6E6;
          stroke: #ffffff;
          stroke-width: 1;
          transition: fill 0.3s ease;
        }
        .nigeria-map.highlight-all path {
          fill: #007DD6;
        }
        .nigeria-map.highlight-all path:hover {
          fill: #005bb5;
        }
        ${stateRules}
      `}</style>
      <NigeriaMapSvg />
    </div>
  )
}

export default NigeriaMap
